import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
// import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IAttendee, {
  IAttendeeCheckHistory,
  ISessionScan,
} from "../../dataProvider/interfaces/IAttendee";

import moment from "moment-timezone";
import FdTypography from "../UIComponents/Typography/FdTypography";

export interface IProps {
  attendee: IAttendee;
  timezone: string;
}

interface timelineNode {
  time: string;
  action: string;
  location: string;
  device: string;
  operator: string;
  identificationMode: string;
  goingIn: boolean;
  message: string;
}

/* Map each action type to a human readable message */
const checkHistoryToTimelineNode = (checkHistory: IAttendeeCheckHistory) => {
  let action: string;
  let goingIn: boolean;
  switch (checkHistory.type.id) {
    case 1:
      action = "Check-in";
      goingIn = true;
      break;
    case 2:
      action = "Check-out";
      goingIn = false;
      break;
    default:
      action = checkHistory.type.name;
      goingIn = false;
      break;
  }
  const identificationMode =
    checkHistory.checkinMode === "Barcode"
      ? "QR/Barcode scan"
      : checkHistory.checkinMode;

  return {
    time: checkHistory.checkAt,
    action: action,
    location: checkHistory.location,
    device: checkHistory.device,
    operator: checkHistory.operator,
    identificationMode: identificationMode,
    goingIn: goingIn,
    message: `${action} at ${
      checkHistory.location || "unknown location"
    } via ${identificationMode} by ${checkHistory.operator}`,
  };
};

const sessionScanToTimelineNode = (sessionScan: ISessionScan) => {
  let action: string;
  let goingIn: boolean;
  switch (sessionScan.type) {
    case "SCAN_IN":
      action = "Join session";
      goingIn = true;
      break;
    case "SCAN_OUT":
      action = "Leave session";
      goingIn = false;
      break;
    default:
      action = sessionScan.type;
      goingIn = false;
      break;
  }

  const session = "";

  return {
    time: sessionScan.scanAt,
    action: action,
    location: session,
    device: "",
    operator: "",
    identificationMode: "QR/Barcode scan",
    goingIn: goingIn,
    message: ``,
  };
};

export const getTimeline: (attendee: IAttendee) => timelineNode[] = (
  attendee: IAttendee
) => {
  const firstName = attendee.fieldValues.fname || attendee.firstName || "";
  const lastName = attendee.fieldValues.lname || attendee.lastName || "";
  const name = [firstName, lastName].join(" ");

  const timeline: timelineNode[] = [
    {
      time: attendee.createdAt || "",
      action: "Record created",
      location: "",
      device: "",
      operator: "",
      identificationMode: "",
      goingIn: false,
      message: `Record created ${name ? "for " + name : ""}`,
    },
    ...(attendee.attendeeCheckHistories || []).map(checkHistoryToTimelineNode),
    ...(attendee.scans || []).map(sessionScanToTimelineNode),
  ];

  timeline.sort(
    (a, b) => new Date(a.time).valueOf() - new Date(b.time).valueOf()
  );

  return timeline;
};

const AttendeeTimeline = ({ attendee, timezone }: IProps) => {
  const timeline = getTimeline(attendee);

  return (
    <Box>
      <Timeline>
        {timeline.map((node) => (
          <TimelineItem key={`${node.time}_${node.device}`}>
            <TimelineOppositeContent
              sx={{
                flex: 0,
                minWidth: "9em",
              }}
            >
              <FdTypography color="textSecondary" label= {moment.utc(node.time).tz(timezone).format("YYYY-MM-DD HH:mm")} />
               
                {/* {node.goingIn ? node.time : node.action} */}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <FdTypography color="textSecondary" label={
                <>
                       <Box component="span" fontWeight="fontWeightBold">
                  {node.action}
                </Box>
                {node.location && (
                  <>
                    {" at "}
                    <Box component="span" fontWeight="fontWeightBold">
                      {node.location}
                    </Box>
                  </>
                )}
                {node.operator && (
                  <>
                    {" by "}
                    <Box component="span" fontWeight="fontWeightBold">
                      {node.operator}
                    </Box>
                  </>
                )}
                {node.identificationMode && (
                  <>
                    {" via "}
                    <Box component="span" fontWeight="fontWeightBold">
                      {node.identificationMode}
                    </Box>
                  </>
                )}
                </>
              } />
         
                {/* {node.goingIn ? node.action : node.time} */}
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </Box>
  );
};

export default AttendeeTimeline;
